export default __webpack_public_path__ + "media/images/admin/info-933d74052294c591a26d31daeba43bfd.svg";